var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.291 17.2429V8.21006M8.77461 14.9847V10.4683M17.2429 14.9847V10.4683M13.0087 24.0175C19.0887 24.0175 24.0175 19.0887 24.0175 13.0087C24.0175 6.92878 19.0887 2 13.0087 2C6.92878 2 2 6.92878 2 13.0087C2 14.7698 2.41351 16.4342 3.14872 17.9104C3.3441 18.3026 3.40913 18.751 3.29586 19.1743L2.64017 21.625C2.35553 22.6887 3.32877 23.6619 4.39259 23.3773L6.84318 22.7217C7.26651 22.6084 7.71487 22.6734 8.10713 22.8687C9.58323 23.604 11.2477 24.0175 13.0087 24.0175Z",
    stroke: "#C3C3C3",
    strokeWidth: 2.20175,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.3858fd3d13ea2b803a7ba6047f395dce.svg";
export { ForwardRef as ReactComponent };